import { render, staticRenderFns } from "./navbar-item.vue?vue&type=template&id=99f3e548&scoped=true"
import script from "./navbar-item.vue?vue&type=script&lang=js"
export * from "./navbar-item.vue?vue&type=script&lang=js"
import style0 from "./navbar-item.vue?vue&type=style&index=0&id=99f3e548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f3e548",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/code/navbar-item.vue
// module id = null
// module chunks = 